import { render, staticRenderFns } from "./qaHistory.vue?vue&type=template&id=503c2eb6&scoped=true&"
import script from "./qaHistory.vue?vue&type=script&lang=js&"
export * from "./qaHistory.vue?vue&type=script&lang=js&"
import style0 from "./qaHistory.vue?vue&type=style&index=0&id=503c2eb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c2eb6",
  null
  
)

export default component.exports